var map = {
	"./love.png": 1227,
	"./music.png": 3891,
	"./weather/bingbao.png": 3375,
	"./weather/lei.png": 6647,
	"./weather/qing.png": 9654,
	"./weather/shachen.png": 2444,
	"./weather/wu.png": 5635,
	"./weather/xue.png": 2778,
	"./weather/yin.png": 7437,
	"./weather/yu.png": 2128,
	"./weather/yun.png": 4946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;